<script>
/* eslint-disable no-unused-vars */
import { Doughnut } from "vue-chartjs";
export default {
  extends: Doughnut,
  props: {
    chartData: {
      type: Object,
      default: null
    },
    chartOptions: {
      type: Object,
      default: null
    }
  },
  mounted() {
    // this.refreshChart();
  },
  methods: {
    refreshChart: function() {
      const that = this;
      this.renderChart(this.chartData, {
        responsive: true,
        maintainAspectRatio: false,
        tooltipPosition: "left",
        productComparison: {},
        cutoutPercentage: 70,
        legend: {
          display: false
        },
        tooltips: {
          enabled: false,
          position: "nearest",
          custom: function(tooltipModel) {
            let tooltipEl = document.getElementById("chartjs-tooltip");
            if (!tooltipEl) {
              tooltipEl = document.createElement("div");
              tooltipEl.id = "chartjs-tooltip";
              tooltipEl.innerHTML = "<table></table>";
              document.body.appendChild(tooltipEl);
            }

            const options = this._chart.options;
            const formatter = options.productComparison.formatter || (v => v);

            if (tooltipModel.opacity === 0) {
              tooltipEl.style.opacity = 0;
              return;
            }

            tooltipEl.classList.remove("above", "below", "no-transform", "top", "bottom", "center", "left", "right");
            if (tooltipModel.yAlign || tooltipModel.xAlign) {
              tooltipEl.classList.add(tooltipModel.yAlign);
              tooltipEl.classList.add(tooltipModel.xAlign);
            } else {
              tooltipEl.classList.add("no-transform");
            }

            const label = this._chart.data.labels[tooltipModel.dataPoints[0].index];

            let rowsHtml = `
                  <tr>
                      <td colspan="2">${that.lodash.startCase(label)}</td>
                  </tr>
            `;

            if (tooltipModel.dataPoints[0].index === 0) {
              const not_yet_due_receivables = options.not_yet_due_receivables;
              rowsHtml += `
                <tr>
                  <td rowspan="2" style="width: 18px">
                    <div style="width: 12px; height: 12px; background: ${
                      tooltipModel.labelColors[0].backgroundColor
                    };border-radius: 24px;"></div>
                  </td>
                  <td>${that.$numeral(not_yet_due_receivables).format("$ 0,0")}</td>
                </tr>`;
            } else {
              const due_receivables = options.due_receivables;
              due_receivables.forEach((item, index) => {
                rowsHtml += `
                  <tr>
                    <td style="width: 18px">
                      <div style="width: 12px; height: 12px; background: ${
                        tooltipModel.labelColors[0].backgroundColor
                      };border-radius: 24px;"></div>
                    </td>
                    <td>DPD ${index * 30 || 1}+</td>
                  </tr>
                  <tr>
                      <td></td>
                      <td>${that.$numeral(item).format("$ 0,0")}</td>
                  </tr>`;
              });
            }

            let innerHtml = `
              <tbody>
                ${rowsHtml}
              </tbody>
            `;

            var tableRoot = tooltipEl.querySelector("table");
            tableRoot.innerHTML = innerHtml;

            const position = this._chart.canvas.getBoundingClientRect();

            const tooltipPositionStyle = {
              right: {
                left: position.left + window.pageXOffset + tooltipModel.caretX + "px",
                top: position.top + window.pageYOffset + tooltipModel.caretY * 10 + "px"
              },
              left: {
                left: position.left + window.pageXOffset + tooltipModel.caretX - tooltipEl.offsetWidth - 4 + "px",
                top: position.top + window.pageYOffset + tooltipModel.caretY * 10 + "px"
              }
            };

            tooltipEl.style.opacity = 1;
            tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + "px";
            tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + "px";
            tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
            tooltipEl.style.fontSize = tooltipModel.bodyFontSize + "px";
            tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
            tooltipEl.style.padding = tooltipModel.yPadding + "px " + tooltipModel.xPadding + "px";
            tooltipEl.style.zIndex = 999;
          }
        },
        ...this.chartOptions
      });
    }
  }
};
</script>

<style lang="scss">
#chartjs-tooltip {
  transition: top 0.2s ease-in-out, left 0.2s ease-in-out;
  opacity: 1;
  position: absolute;
  pointer-events: none;
  background-color: rgba(18, 19, 26, 0.8);
  color: white;
  border-radius: 4px;
  //
  //&.bottom {
  //  transform: translate(-50%, 0)
  //}
  //
  //&.bottom:before {
  //  border: solid;
  //  border-color: #111 transparent;
  //  border-color: rgba(0, 0, 0, .8) transparent;
  //  border-width: 0 8px 8px 8px;
  //  bottom: 1em;
  //  content: "";
  //  display: block;
  //  left: 50%;
  //  position: absolute;
  //  z-index: 99;
  //  transform: translate(-50%, -100%);
  //}
  //
  //&.top {
  //  transform: translate(-50%, -100%);
  //}
  //
  //&.top:before {
  //  border: solid;
  //  border-color: #111 transparent;
  //  border-color: rgba(0, 0, 0, .8) transparent;
  //  border-width: 8px 8px 0 8px;
  //  bottom: 1em;
  //  content: "";
  //  display: block;
  //  left: 50%;
  //  top: 100%;
  //  position: absolute;
  //  z-index: 99;
  //  transform: translate(-50%, 0);
  //}
  //
  //&.left {
  //  transform: translate(0, -50%);
  //}
  //&.left:before {
  //  border: solid;
  //  border-color: #111 transparent;
  //  border-color: rgba(0, 0, 0, .8) transparent;
  //  border-width: 8px 8px 8px 0;
  //  content: "";
  //  display: block;
  //  left: 100%;
  //  position: absolute;
  //  top: 50%;
  //  transform: translate(0, -50%);
  //  z-index: 99;
  //}
}
</style>
